<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 7.97058V4.97058C19 4.70536 18.8946 4.45101 18.7071 4.26347C18.5196 4.07594 18.2652 3.97058 18 3.97058H5C4.46957 3.97058 3.96086 4.18129 3.58579 4.55637C3.21071 4.93144 3 5.44015 3 5.97058C3 6.50101 3.21071 7.00972 3.58579 7.38479C3.96086 7.75987 4.46957 7.97058 5 7.97058H20C20.2652 7.97058 20.5196 8.07594 20.7071 8.26347C20.8946 8.45101 21 8.70536 21 8.97058V12.9706M21 12.9706H18C17.4696 12.9706 16.9609 13.1813 16.5858 13.5564C16.2107 13.9314 16 14.4401 16 14.9706C16 15.501 16.2107 16.0097 16.5858 16.3848C16.9609 16.7599 17.4696 16.9706 18 16.9706H21C21.2652 16.9706 21.5196 16.8652 21.7071 16.6777C21.8946 16.4902 22 16.2358 22 15.9706V13.9706C22 13.7054 21.8946 13.451 21.7071 13.2635C21.5196 13.0759 21.2652 12.9706 21 12.9706Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3 5.97058V19.9706C3 20.501 3.21071 21.0097 3.58579 21.3848C3.96086 21.7599 4.46957 21.9706 5 21.9706H20C20.2652 21.9706 20.5196 21.8652 20.7071 21.6777C20.8946 21.4902 21 21.2358 21 20.9706V16.9706" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#78829D',
      required: false,
    },
  },
};
</script>
